import { Spin, Upload } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import UploadImg from '@/assets/imges/upload.png'
const { Dragger } = Upload
interface UpLoadFileProps extends React.ComponentProps<typeof Dragger> {
  text: string | JSX.Element | JSX.Element[]
  uploadXlsxLoading: boolean
}
export const UpLoadFile = (props: UpLoadFileProps) => {
  const { text, uploadXlsxLoading, ...other } = props
  const antIcon = <LoadingOutlined style={{ fontSize: 36 }} spin />

  return (
    <UpLoadFileContainer {...other}>
      {uploadXlsxLoading ? (
        <Spin indicator={antIcon} />
      ) : (
        <img src={UploadImg} alt="" height={80} />
      )}
      <div className="test-container">{text}</div>
    </UpLoadFileContainer>
  )
}

const UpLoadFileContainer = styled(Dragger)`
  border-color: #d9d9d9;
  background-color: #fbfbfc !important;
  padding-bottom: 14px;
  /* background-color: red !important; */
  .test-container {
    margin-top: 14px;
  }
  &:hover {
    border-color: #2e3d5e !important;
    .icon {
      color: #2e3d5e;
    }
  }
`
